import { getApplicatorGroups } from "@/api/api";
import { useRequest } from "ahooks";
import { useState } from "react";

const UseGetApplicatorGroups = () => {
    const [groups , setGroups] = useState<any>([]);

    const { run: fetchApplicatorGroups, loading: applicatorGroupsLoading } = useRequest(getApplicatorGroups,{
        manual: true,
        onSuccess: (data) => {
            setGroups(data?.groups)
        }
    }) 
    
    return { fetchApplicatorGroups, applicatorGroupsLoading, groups };
}
 
export default UseGetApplicatorGroups;